import { useState, useEffect } from 'react'
import { api } from '../../Controllers/api'

export function useProjects() {
  const [projectsListFull, setProjectsListFull] = useState()
  const [error, setError] = useState()
  const [loading, setLoading] = useState(true)

  const refreshProjects = () => {
    api
      .get('projects')
      .then(({ data }) => {
        // setProjectsList(data)
        setProjectsListFull(data)
        setLoading(false)
      })
      .catch(err => setError(err))
  }

  const archiveUnarchiveProject = (_id, archiveUnarchive) => {
    api
      .put(`projects/${archiveUnarchive}/${_id}`)
      .then(data => {
        refreshProjects()
      })
      .catch(err => setError(err))
  }

  useEffect(() => {
    refreshProjects()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return { loading, projectsListFull, refreshProjects, archiveUnarchiveProject, error }
}

export function useCreateProjectModal() {
  const [createNewProjectModal, setVisible] = useState(false)

  const handleCreateProjectModal = () => {
    setVisible(!createNewProjectModal)
  }

  return { createNewProjectModal, handleCreateProjectModal }
}

export function useEditProjectModal() {
  const [editProjectModal, setVisible] = useState(false)

  const handleEditProjectModal = () => {
    setVisible(!editProjectModal)
  }

  return { editProjectModal, handleEditProjectModal }
}
